import { DateTime } from 'luxon';

import { Address } from './Address';
import { BillingData } from './BillingData';
import { InstallationData } from './InstallationData';
import { Product } from './Product';
import { ShippingData } from './ShippingData';
import { GlossaryText } from './GlossaryText';

const CHECKOUT_STATUS = {
  BILLED: 'billed',
  CONFIRMED: 'confirmed',
  DISABLED: 'disabled',
  PENDING: 'pending',
  PENDING_PAYMENT: 'pending_payment',
  REJECT_PAYMENT: 'reject_payment',
};

const CHECKOUT_TYPES = {
  ONLINE: 'online',
  PHONE: 'phone',
  ON_SITE: 'onSite',
};

class Checkout {
  constructor(params) {
    this.additionalNotes = params.additionalNotes;
    this.address = params.address ? new Address(params.address) : null;
    this.billingData = new BillingData(params.billingData);
    this.cart = params.cart.map(cartData => (
      {
        product: new Product(cartData.product),
        amount: cartData.amount,
        serviceAmount: cartData.serviceAmount,
      }
    ));
    this.totalProductPrice = this.cart.reduce((acc, item) => (
      acc + (item.amount * item.product.financing.price)
    ), 0);
    this.tokenBilling = params.tokenBilling;
    this.cancellable = params.cancellable;
    this.payable = params.payable;
    this.checkoutType = params.checkoutType;
    this.date = DateTime.fromJSDate(params.date);
    this.id = String(params.id);
    this.information = (params.information || []).map(elem => new GlossaryText(elem));
    this.informationBottom = (params.informationBottom || []).map(elem => new GlossaryText(elem));
    this.installationData = (params.installationData || []).map(data => new InstallationData(data));
    this.invoiceNumber = params.invoiceNumber;
    this.paymentType = params.paymentType;
    this.paymentTypeName = params.paymentTypeName;
    this.shippingData = params.shippingData ? new ShippingData(params.shippingData) : null;
    this.status = params.status;
    this.statusMessage = params.statusMessage;
    this.totalPrice = params.totalPrice;
    this.requestBank = params.requestBank;
    this.bank = params.bank;

    // The cart needs to have the information of which products
    // have installations. This information is stored on the installation data.
    this._updateCartWithInstallations();
    this._removeInstallationProductsFromCart();
  }

  _updateCartWithInstallations() {
    this.installationData.forEach((data) => {
      const cartItem = this.cart.find(item => item.product.id === data.productId);
      const installationAmount = data.selectedOptions.reduce((acc, option) => (
        acc + option.amount
      ), 0);
      cartItem.serviceAmount += installationAmount;
    });
  }

  _removeInstallationProductsFromCart() {
    this.cart = this.cart.filter(item => !item.product.isService);
  }

  isStillOpen() {
    return (this.status === CHECKOUT_STATUS.CONFIRMED ||
      this.status === CHECKOUT_STATUS.PENDING || CHECKOUT_STATUS.PENDING_PAYMENT);
  }

  allowsCoordinations() {
    // Coordinations are allowed only if the checkout has an address and the order wasn't cancelled.
    return !!this.address && this.status !== CHECKOUT_STATUS.DISABLED;
  }
}

export { Checkout, CHECKOUT_STATUS, CHECKOUT_TYPES };



// WEBPACK FOOTER //
// ./src/models/Checkout.js